import ApiService from "service/Api";
import { CollectPointPayloadTypes } from "utilities/types/CollectPoint";

const CollectPointService = {
  getAllCollectPoints: async (
    page: number,
    search: string,
    limit: number,
    filterTenant: number
  ) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        search: search,
        page: page,
        per_page: limit,
        filter_tenant: filterTenant,
      },
      url: "/admin/collect-points",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  storeCollectPoint: async (payload: CollectPointPayloadTypes) => {
    const { pointRewardCollected, pointXpCollected, tenantId } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        point_reward_collected: pointRewardCollected,
        point_xp_collected: pointXpCollected,
        tenant_id: tenantId,
      },
      url: "/admin/collect-points",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  updateCollectPoint: async (
    collectPointId: string,
    payload: CollectPointPayloadTypes
  ) => {
    const { pointRewardCollected, pointXpCollected, tenantId } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        point_reward_collected: pointRewardCollected,
        point_xp_collected: pointXpCollected,
        tenant_id: tenantId,
        _method: "PUT",
      },
      url: "/admin/collect-points/" + collectPointId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  deleteCollectPoint: async (collectPointId: string) => {
    const requestData = {
      method: "delete",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "/admin/collect-points/" + collectPointId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  importCollectPoint: async (importFile: File) => {
    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        file: importFile,
      },
      url: "/admin/collect-points/import",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default CollectPointService;
